import { UserManagementComponent } from './user-management/user-management.component';
import { UserCreateComponent } from './user-create/user-create.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { ComponentsModule } from './../../components/components.module';
import { UserEditComponent } from './user-edit/user-edit.component';
import { SubHeaderComponent } from '../../components/sub-header/sub-header.component';
import { MaterialModule } from './../../material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { UserEffects } from './state/user.effects';

import * as fromUsers from './state/user.reducer';
import { StoreModule } from '@ngrx/store';
import { UserChangePasswordComponent } from './user-change-password/user-change-password.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [
		UserDetailComponent,
		UserManagementComponent,
		UserEditComponent,
		UserCreateComponent,
		SubHeaderComponent,
		UserChangePasswordComponent,
	],
	imports: [
		CommonModule,
		MaterialModule,
		ComponentsModule,
		ReactiveFormsModule,
		TranslateModule,
		EffectsModule.forFeature([UserEffects]),
		StoreModule.forFeature('userContext', fromUsers.userReducer),
	],
})
export class UserModule {}
